import { render, staticRenderFns } from "./cityselector.vue?vue&type=template&id=1d52c23a"
import script from "./cityselector.vue?vue&type=script&lang=ts"
export * from "./cityselector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports